import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core';
import { formatDateToDDMMYYYYHHSSFrEpoch } from '../../utils/util';
import CustomTypo from '../../components/CustomTypo';
import t from '../../utils/translateUtil';
import DrawerCustom from '../../components/DrawerCustom';
import CustomizedCircularProgress from '../../components/CircularProgress';
import DividerCustom from '../../components/Divider'
import InfiniteScroll from 'react-infinite-scroll-component';
import ButtonCustom from '../../components/ButtonCustom';
import classNames from 'classnames';
import { custom_assets, domainName } from '../../../portal.config';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { portalCfg } from '../../../portal.router.config';
import { getAppCfg } from '../../utils/common';
import ResponsiveImages from '../../components/ReponsiveImages';

const drawerWidth = 520;
var path = custom_assets[domainName] && custom_assets[domainName].customImage && custom_assets[domainName].customImage.logo ? portalCfg.publicPath + "/custom_assets" : portalCfg.publicPath + "/assets";


const styles = theme => ({
    container: {
        // borderWidth:1,
        borderRadius: 10,
        backgroundColor: theme.palette.background.box,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(16),
        // height: 230,
    },
    item: {
        // width: 200,
        // height: 200,
        marginLeft: '5%',
        marginRight: '5%',
        // border: '1px solid',
        // borderColor: theme.palette.border.primary,
        // justifyContent: 'center',
        alignItems: 'center',
        borderRadius: theme.spacing(3),
        cursor: 'pointer',
        background: theme.palette.background.secondary,
        marginBottom: theme.spacing(3),
    },
    item_image: {
        // height: 100,
        padding: theme.spacing(3, 0),
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        textAlign: 'center',
        // marginTop: 8,
    },
    item_name: {
        // padding: theme.spacing(1.5, 0)
    },
});

function ProductsView(props) {
    const { classes, t, listProducts, showLoading, handleLoadMore, hasMore, showLoadMore, onClickDetail, serviceSelected } = props;
    console.log("AAAA ProductView props: ", props)
    var app_config = getAppCfg();
    let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
    return (
        <DrawerCustom
            open={props.open}
            onClose={props.onClose}
            title={"Change Service"}
            large={true}
            backgroundWhite={true}
            children={
                <Grid item>
                    <Grid item container justify='center' alignItems='center'>
                        {showLoading && <CustomizedCircularProgress />}
                    </Grid>
                    {listProducts && <Grid xs={12} item>
                        <InfiniteScroll
                            dataLength={listProducts.length} //This is important field to render the next data
                            next={handleLoadMore}
                            hasMore={hasMore}
                            loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                            height={window.innerHeight}
                        >
                            <Grid xs={12} item container className={classes.item_list}>
                                {listProducts.map((item, index) => (
                                    <ProductItem
                                        classes={classes}
                                        key={index}
                                        product={item}
                                        currency={props.currency}
                                        business_logo={business_logo}
                                        onClickDetail={onClickDetail}
                                        serviceSelected={serviceSelected}
                                    />
                                )
                                )}
                            </Grid>
                        </InfiniteScroll>
                    </Grid>}
                </Grid>
            } />
    );
}

function ProductItem(props) {
    var { classes, product, serviceSelected, business_logo } = props;
    let currentPriceId = serviceSelected?.price?.id || null;
    console.log("currentPriceId===", currentPriceId);
    let prices = [];
    if(product.prices && product.prices.length > 0){
        prices = product.prices.filter(x => x.price > 0 && x.id != currentPriceId);
        console.log("prices ===", prices);
    }
    var price = prices && prices.length > 0 ? prices[0] : null;
    var price_terms = price && price.price_terms ? price.price_terms : null;
    console.log("business_logo===", business_logo);
    let productImages = product.creatives ? dataUtil.getImageByUsageType(product.creatives, 'IMAGE') : [];
    // if (!price) return null;
    return (
        <Grid item xs={12} sm={6}>
        <Grid item xs={12} onClick={() => props.onClickDetail(product)} className={classes.item}>
            <Grid item className={classes.item_image}>
                {/* <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(product.creatives, usage_type.product_item)} /> */}
                {productImages && productImages.length > 0 ? <ResponsiveImages 
                    media={productImages}
                    css={{
                        height: 250,
                        objectFit: 'contain',
                        width: '100%'
                    }}
                />
                :<img src={business_logo?.url} alt={product.name} style={{ height: 150, borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }}></img>}
            </Grid>
            <Grid item className={classes.item_name}>
                <CustomTypo variant='subtitle1' center>{product.name}</CustomTypo>
            </Grid>
            {/* {productImages && productImages.length == 0 && <> */}
                {price_terms && price_terms.billing_period && <Grid item className={classes.item_name}>
                    <CustomTypo variant='subtitle1' center>{t('billing_period')}: {price_terms.billing_period.duration}{price_terms.billing_period.uot}</CustomTypo>
                </Grid>}
                {price_terms && price_terms.contract_period && <Grid item className={classes.item_name}>
                    <CustomTypo variant='subtitle1' center>{t('contract_period')}: {price_terms.contract_period.duration}{price_terms.contract_period.uot}</CustomTypo>
                </Grid>}
                <Grid item className={classes.item_footer}>
                    <CustomTypo center mg_top_xs variant='h6'>{props.currency}{price && price.price ? price.price : null}</CustomTypo>
                </Grid>
            {/* </>} */}
        </Grid>
        </Grid>
    )
}

function ProductImage(props) {
    var { classes, image } = props
    if (image && image.url) {
        return <img src={image.url} style={{ height: 100, width: '100%', borderTopLeftRadius: 4, borderTopRightRadius: 4, objectFit: 'contain' }} />
    } else {
        return <Grid item className={classes.item_image} />
    }
}

export default withStyles(styles)(withTranslation()(ProductsView));